// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../primitives/I18n.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let values = [
  "SA",
  "SAS",
  "SARL",
  "EI",
  "EIRL",
  "EURL",
  "MICRO",
  "SNC",
  "SCS",
  "SCA"
];

function toString(value) {
  switch (value) {
    case "SA" :
      return "SA";
    case "SAS" :
      return "SAS";
    case "SARL" :
      return "SARL";
    case "EI" :
      return "EI";
    case "EIRL" :
      return "EIRL";
    case "EURL" :
      return "EURL";
    case "MICRO" :
      return "MICRO";
    case "SNC" :
      return "SNC";
    case "SCS" :
      return "SCS";
    case "SCA" :
      return "SCA";
  }
}

function fromString(value) {
  switch (value) {
    case "EI" :
      return {
        TAG: "Ok",
        _0: "EI"
      };
    case "EIRL" :
      return {
        TAG: "Ok",
        _0: "EIRL"
      };
    case "EURL" :
      return {
        TAG: "Ok",
        _0: "EURL"
      };
    case "MICRO" :
      return {
        TAG: "Ok",
        _0: "MICRO"
      };
    case "SA" :
      return {
        TAG: "Ok",
        _0: "SA"
      };
    case "SARL" :
      return {
        TAG: "Ok",
        _0: "SARL"
      };
    case "SAS" :
      return {
        TAG: "Ok",
        _0: "SAS"
      };
    case "SCA" :
      return {
        TAG: "Ok",
        _0: "SCA"
      };
    case "SCS" :
      return {
        TAG: "Ok",
        _0: "SCS"
      };
    case "SNC" :
      return {
        TAG: "Ok",
        _0: "SNC"
      };
    default:
      return {
        TAG: "Error",
        _0: "Unknown legal form"
      };
  }
}

function compare(a, b) {
  return Primitive_int.compare(b.length, a.length);
}

let CompanyLegalForm = {
  values: values,
  toString: toString,
  fromString: fromString,
  compare: compare
};

function sanitize(value) {
  return value.replace(/\s+/g, "");
}

function stripIban(value) {
  return value.replace(new RegExp("[^A-Za-z0-9]+"), "").toUpperCase();
}

function getIbanComponents(ibanStripped) {
  return Primitive_option.fromNullable(new RegExp("^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$").exec(ibanStripped));
}

function numericiseIban(bban, country, checkDigits) {
  return (bban + country + checkDigits).split("").map(ch => {
    if (ch.charCodeAt(0) >= "A".charCodeAt(0) && ch.charCodeAt(0) <= "Z".charCodeAt(0)) {
      return (ch.charCodeAt(0) - 55 | 0).toString();
    } else {
      return ch;
    }
  }).join("");
}

function findAllMatches(regex, numbericed) {
  let _acc = [];
  while (true) {
    let acc = _acc;
    let result = regex.exec(numbericed);
    if (result == null) {
      return acc;
    }
    let match = Stdlib_Option.getOrThrow(result[0], undefined);
    _acc = Belt_Array.concatMany([
      acc,
      [match]
    ]);
    continue;
  };
}

function computeMod97(matches) {
  return Stdlib_Array.reduce(matches, "", (total, curr) => (Stdlib_Option.getOr(Stdlib_Int.fromString(total + Stdlib_Option.getOr(curr, ""), undefined), 0) % 97).toString());
}

function validate(value) {
  let trimmedIban = sanitize(value);
  if (!new RegExp("^([A-Za-z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Za-z0-9]){9,30}$)((?:[ \\-]?[A-Za-z0-9]{3,5}){2,6})([ \\-]?[A-Za-z0-9]{1,3})?$").test(trimmedIban)) {
    return false;
  }
  let ibanStripped = stripIban(trimmedIban);
  let ibanComponents = getIbanComponents(ibanStripped);
  if (ibanComponents === undefined) {
    return false;
  }
  let country = Stdlib_Option.getOrThrow(ibanComponents[1], undefined);
  let checkDigits = Stdlib_Option.getOrThrow(ibanComponents[2], undefined);
  let bban = Stdlib_Option.getOrThrow(ibanComponents[3], undefined);
  if (country === undefined) {
    return false;
  }
  if (checkDigits === undefined) {
    return false;
  }
  if (bban === undefined) {
    return false;
  }
  let numbericed = numericiseIban(bban, country, checkDigits);
  let regex = new RegExp("\\d{1,7}", "g");
  let matches = findAllMatches(regex, numbericed);
  return computeMod97(matches) === "1";
}

function fromString$1(value) {
  return Stdlib_Float.fromString(value.replace(/[^\d,.-]/g, "").replace(/,/g, "."));
}

function toString$1(value) {
  return I18n.currencyFormat(undefined, "EUR", undefined, undefined, value);
}

let ShareCapital = {
  fromString: fromString$1,
  toString: toString$1
};

let prefixes = values.map(toString);

function strippedCorporateName(corporateName) {
  return Stdlib_Array.reduce(prefixes.toSorted(compare), corporateName, (acc, prefixe) => acc.replace(prefixe, "")).trim();
}

function validate$1(corporateName) {
  return strippedCorporateName(corporateName).length >= 2;
}

let Iban = {
  sanitize: sanitize,
  validate: validate
};

let CorporateName = {
  validate: validate$1
};

export {
  CompanyLegalForm,
  Iban,
  ShareCapital,
  CorporateName,
}
/* prefixes Not a pure module */
